export default __webpack_public_path__ + "static/media/wh_icon_joomla.adaa84b2.svg";